import { matchPath } from "react-router-dom";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";

type BreadcrumbRule = {
  path: string;
  crumbs: (params: Record<string, string | undefined>) => BreadcrumbItem[];
};

const inventory = (): BreadcrumbItem => ({
  labelKey: "Inventory",
});

/** Inventory sidebar module routes — more specific paths first. */
const INVENTORY_BREADCRUMB_RULES: BreadcrumbRule[] = [
  // Stock level
  {
    path: "/inventory/stock-level",
    crumbs: () => [inventory(), { labelKey: "stockLevel" }],
  },

  // Stock adjustments
  {
    path: "/inventory/stock-adjustments",
    crumbs: () => [inventory(), { labelKey: "StockAdjustments" }],
  },
  {
    path: "/inventory/stock-adjustment",
    crumbs: () => [
      inventory(),
      { labelKey: "StockAdjustments", href: "/inventory/stock-adjustments" },
      { labelKey: "create" },
    ],
  },
  {
    path: "/inventory/stock-adjustment/:id/print",
    crumbs: (p) => [
      inventory(),
      { labelKey: "StockAdjustments", href: "/inventory/stock-adjustments" },
      {
        labelKey: "Details",
        href: p.id ? `/inventory/stock-adjustment/${p.id}` : undefined,
      },
      { labelKey: "print" },
    ],
  },
  {
    path: "/inventory/stock-adjustment/:id",
    crumbs: () => [
      inventory(),
      { labelKey: "StockAdjustments", href: "/inventory/stock-adjustments" },
      { labelKey: "Details" },
    ],
  },

  // Stock transfers
  {
    path: "/inventory/stock-transfers",
    crumbs: () => [inventory(), { labelKey: "StockTransfers" }],
  },
  {
    path: "/inventory/stock-transfer",
    crumbs: () => [
      inventory(),
      { labelKey: "StockTransfers", href: "/inventory/stock-transfers" },
      { labelKey: "create" },
    ],
  },
  {
    path: "/inventory/stock-transfer/:id/print",
    crumbs: (p) => [
      inventory(),
      { labelKey: "StockTransfers", href: "/inventory/stock-transfers" },
      {
        labelKey: "Details",
        href: p.id ? `/inventory/stock-transfer/${p.id}` : undefined,
      },
      { labelKey: "print" },
    ],
  },
  {
    path: "/inventory/stock-transfer/:id",
    crumbs: () => [
      inventory(),
      { labelKey: "StockTransfers", href: "/inventory/stock-transfers" },
      { labelKey: "Details" },
    ],
  },
];

export const getInventoryBreadcrumbs = (
  pathname: string,
): BreadcrumbItem[] | null => {
  for (const rule of INVENTORY_BREADCRUMB_RULES) {
    const match = matchPath({ path: rule.path, end: true }, pathname);
    if (match) {
      return rule.crumbs(match.params as Record<string, string | undefined>);
    }
  }
  return null;
};
